export default __webpack_public_path__ + "static/media/remodel6.451b117d.png";